export const FULL_REVERSE = 'Full Reverse';
export const MAX_REMARKS = 1000;

export const MSG = {
    selectType: 'Select Receipt Type',
    enterRemarks: 'Enter Remarks',
    selectLine: 'Select any receipt',
    unclearedCheque: 'Cheque is not cleared.',
    amountRequired: 'Allocate Amount should not be blank or zero.',
    amountExceeded: 'Amount Exceeded',
    duplicate: 'Payment type already exist.',
    fullReverseMixed: 'Full Reverse cannot be combined with other transaction types. Reset the list first.',
    noLines: 'Select a lease or enter a receipt no.',
    listEmpty: 'Allocation not completed',
    dateRequired: 'Select Transaction Date',
};

export const num = (v) => {
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
};
export const round3 = (v) => Math.round((num(v) + Number.EPSILON) * 1000) / 1000;
export const fmt3 = (v) => round3(v).toFixed(3);

const same = (a, b) => `${a ?? ''}`.trim().toLowerCase() === `${b ?? ''}`.trim().toLowerCase();

/** Builds one Reversal List row from a receipt line. `account` is a { value, label } option or null. */
export const toListRow = (line, { transactionType, amount, remarks, account }) => ({
    recordId: line.recordId,
    leaseNo: line.leaseNo,
    receiptNo: line.receiptNo,
    installmentDesc: line.installmentDesc,
    propertyName: line.propertyName,
    unitNo: line.unitNo,
    tenantName: line.tenantName,
    transactionType,
    amount: round3(amount),
    remarks: `${remarks ?? ''}`.trim(),
    refundAccountCode: account?.value ?? null,
    refundAccountName: account?.label ?? '',
});

/**
 * Validates an Allocate click for every type except Full Reverse. Returns the first error message, or null.
 * Rule order follows the legacy screen.
 * @param {{ transactionType: string, remarks: string, amount: number|string }} panel
 * @param {object|null} selectedLine a receipt line
 * @param {object[]} list the current Reversal List
 */
export const validateAllocation = (panel, selectedLine, list) => {
    if (!`${panel?.transactionType ?? ''}`.trim()) return MSG.selectType;
    if (!`${panel?.remarks ?? ''}`.trim()) return MSG.enterRemarks;
    if (!selectedLine) return MSG.selectLine;
    if (same(panel.transactionType, 'Reverse') && same(selectedLine.paymentMethod, 'PDC') && !same(selectedLine.chequeStatus, 'Cleared')) {
        return MSG.unclearedCheque;
    }
    const amount = num(panel.amount);
    if (amount <= 0) return MSG.amountRequired;
    if (round3(amount) > round3(selectedLine.amountPaid)) return MSG.amountExceeded;
    if ((list || []).some((r) => `${r.recordId}` === `${selectedLine.recordId}`)) return MSG.duplicate;
    if ((list || []).some((r) => r.transactionType === FULL_REVERSE)) return MSG.fullReverseMixed;
    return null;
};

/** Full Reverse: every receipt line currently shown, at its full amount. */
export const buildFullReverse = (lines, remarks, account) =>
    (lines || []).map((line) => toListRow(line, { transactionType: FULL_REVERSE, amount: line.amountPaid, remarks, account }));

export const listTotal = (list) => round3((list || []).reduce((t, r) => t + num(r.amount), 0));

/** @returns {import('../../services/leaseReverseReceiptApi').ReverseReceiptsRequest} */
export const buildSavePayload = (list, reverseDate) => ({
    reverseDate,
    items: list.map((r) => ({
        recordId: r.recordId,
        transactionType: r.transactionType,
        amount: round3(r.amount),
        remarks: r.remarks,
        refundAccountCode: r.refundAccountCode || null,
    })),
});

/** Record ids of list rows whose receipt no a server message mentions, so those rows can be highlighted. */
export const findRowsInMessage = (list, message) => {
    const text = `${message ?? ''}`.toLowerCase();
    if (!text) return [];
    return list.filter((r) => r.receiptNo && text.includes(`${r.receiptNo}`.toLowerCase())).map((r) => r.recordId);
};
